import { render, staticRenderFns } from "./dmp-detail.html?vue&type=template&id=0db200ca&scoped=true&external"
import script from "./dmp-detail.js?vue&type=script&lang=js&external"
export * from "./dmp-detail.js?vue&type=script&lang=js&external"
import style0 from "./dmp-detail.scss?vue&type=style&index=0&id=0db200ca&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db200ca",
  null
  
)

export default component.exports